import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-confirmed-offer',
  imports: [MatCardModule],
  templateUrl: './confirmed-offer.component.html',
  styleUrl: './confirmed-offer.component.scss',
})
export class ConfirmedOfferComponent {
  isConfirmedOfferForCurrentUser = input<boolean>();
}
